import React from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../hooks/useReveal';
import Banner from '../Components/Banner';
import AboutSection from '../Components/AboutSection';
import Services from '../Components/Services';
import ProjectSection from '../Components/ProjectSection';
import HProficiency from '../Components/HProficiency';
import DeveloperStrip from '../Components/DeveloperStrip';

const Home = () => {
    useReveal();

    return (
        <div>
            <Banner />
            <AboutSection compact />
            <DeveloperStrip />
            <Services limit={3} />
            <ProjectSection limit={3} showFilters={false} />
            <div className="section-more">
                <Link className="btn-line" to="/projects">All projects</Link>
            </div>
            <HProficiency />
            <section className="home-cta">
                <div className="container reveal">
                    <h2>Ready to discuss your facade?</h2>
                    <p>Glazing, cladding, aluminium and UPVC work for projects across Delhi NCR.</p>
                    <Link className="hero-btn is-solid" to="/contact">Contact us</Link>
                </div>
            </section>
        </div>
    );
};

export default Home;
